// Form validation for New Project form
import { plaintextValidator } from '../fields';
import { stringMandateConstraints } from '../utils';

const config = { mandatory: true };

export default {
  title: plaintextValidator(config),
  description: plaintextValidator({}),
  addMilestones: {
    array: {
      name: stringMandateConstraints
    }
  }
};
